module.exports = __webpack_public_path__ + "static/media/loadinglogo.d028bf88.svg";